module.exports = __webpack_public_path__ + "img/icon-calendar.3287bff0.svg";